export const SYSTEM_ID_PATTERN = /^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/;

export function normalizeSystemId(value: unknown): string | null {
  const systemId = String(value || '').trim().toLowerCase();
  return SYSTEM_ID_PATTERN.test(systemId) ? systemId : null;
}

export type SystemSelection = {
  systemId: string;
  sanitizedSearch: string;
  searchChanged: boolean;
  storedSystemInvalid: boolean;
};

export function resolveSystemSelection(search: string, storedSystemId: string): SystemSelection {
  const params = new URLSearchParams(search);
  const requestedSystemId = params.get('system');
  const normalizedStoredSystemId = normalizeSystemId(storedSystemId);
  const fallbackSystemId = normalizedStoredSystemId || 'official';

  if (requestedSystemId === null) {
    return {
      systemId: fallbackSystemId,
      sanitizedSearch: search,
      searchChanged: false,
      storedSystemInvalid: !normalizedStoredSystemId,
    };
  }

  const normalizedRequestedSystemId = normalizeSystemId(requestedSystemId);
  if (!normalizedRequestedSystemId) {
    params.delete('system');
    const nextQuery = params.toString();
    return {
      systemId: fallbackSystemId,
      sanitizedSearch: nextQuery ? `?${nextQuery}` : '',
      searchChanged: true,
      storedSystemInvalid: !normalizedStoredSystemId,
    };
  }

  if (requestedSystemId !== normalizedRequestedSystemId) params.set('system', normalizedRequestedSystemId);
  const nextQuery = params.toString();
  return {
    systemId: normalizedRequestedSystemId,
    sanitizedSearch: nextQuery ? `?${nextQuery}` : '',
    searchChanged: requestedSystemId !== normalizedRequestedSystemId,
    storedSystemInvalid: !normalizedStoredSystemId,
  };
}
